import client, { setTokens, clearTokens } from './client';

export const authApi = {
  login: (email, password) =>
    client.post('/auth/login', { email, password }).then((r) => r.data),
  me: () => client.get('/auth/me').then((r) => r.data),
  updateProfile: ({ full_name, email }) =>
    client.patch('/auth/me', { full_name, email }).then((r) => r.data),
  changePassword: ({ current_password, new_password }) =>
    client.post('/auth/change-password', { current_password, new_password }).then((r) => r.data),
  forgotPassword: (email) =>
    client.post('/auth/forgot-password', { email }).then((r) => r.data),
  resetPassword: ({ token, new_password }) =>
    client.post('/auth/reset-password', { token, new_password }).then((r) => r.data),
};

export { setTokens, clearTokens };

export const ROLE_FIRM_OWNER = 'firm_owner';
export const ROLE_TAX_PRO = 'tax_pro';
export const ROLE_CLIENT = 'client';
export const MANAGER_ROLES = [ROLE_FIRM_OWNER, ROLE_TAX_PRO];

export const isManager = (user) => user && MANAGER_ROLES.includes(user.role);
